import { Grid, makeStyles } from '@material-ui/core';
import { isNotBlank } from '@roc/feature-utils';
import {
  AddressDetailsField,
  createDateField,
  createNumberFormatField,
  createSelectField,
  createTextField,
} from '@roc/ui';
import { QuoteTypeStore } from 'libs/feature-one-tool/src/quote/stores/quoteTypeStore';
import { observer } from 'mobx-react';
import { OneToolCard } from './oneToolCard';

const entityTypes = [
  { value: 'Corporation', label: 'Corporation' },
  { value: 'Limited Liability Company', label: 'Limited Liability Company' },
];

export const EntityInformationForm = observer(({ entityFormStore }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        {createTextField({
          label: 'Entity Name',
          fieldName: 'name',
          testId: 'name',
          store: entityFormStore,
          standaloneLabel: false,
        })}
      </Grid>
      <Grid item xs={12} sm={6}>
        {createNumberFormatField({
          label: 'Entity EIN',
          fieldName: 'ein',
          testId: 'ein',
          store: entityFormStore,
          format: '##-#######',
          standaloneLabel: false,
        })}
      </Grid>
      <Grid item xs={12} sm={6}>
        {createSelectField({
          label: 'Entity Type',
          fieldName: 'type',
          testId: 'type',
          options: entityTypes,
          store: entityFormStore,
          standaloneLabel: false,
        })}
      </Grid>
      <Grid item xs={12} sm={6}>
        {createDateField({
          label: 'Date of Incorporation',
          fieldName: 'operatingAgreementDate',
          testId: 'operatingAgreementDate',
          store: entityFormStore,
          standaloneLabel: false,
          disableFuture: true,
        })}
      </Grid>
      <Grid item xs={12}>
        <AddressDetailsField
          name={'__address'}
          value={entityFormStore.form.fields.__address.value}
          onChange={value => {
            entityFormStore.onFieldChange('__address', value);
            entityFormStore.onFieldChange('address', value);
            entityFormStore.onFieldChange('aptNumber', value);
            entityFormStore.onFieldChange('city', value);
            entityFormStore.onFieldChange('state', value);
            entityFormStore.onFieldChange('zipCode', value);
          }}
          required
          standaloneLabel={false}
          error={
            !entityFormStore.form.meta.isValid &&
            isNotBlank(entityFormStore.form.fields.address.error)
          }
          helperText={
            !entityFormStore.form.meta.isValid &&
            entityFormStore.form.fields.address.error
          }
        />
      </Grid>
    </Grid>
  );
});
